<template>
  <div class="box">
    <div class="headBox">
      <div class="bigbox" v-show="!navigationShow" :class="searchShow ? '' : 'bigboxHover'">
        <div class="logo" @click=logo()>
          <img src="../../img/logo.png" class="logo1" alt="" />
          <img src="../../img/logo2.png" class=logo2 alt="" />
        </div>
        <div class="text" @mouseenter="navigationText($event)" @mouseleave="navigationTextLeave()" v-show="searchShow">
          <div class="navigation-text" @mouseenter="enter(0)">
            关于正熙

          </div>
          <div class="navigation-text" @mouseenter="enter(1)">
            产品中心
          </div>
          <div class="navigation-text" @mouseenter="enter(2)">
            学术园地
          </div>
          <div class="navigation-text" @mouseenter="enter(3)">
            资讯信息
          </div>
          <div class="navigation-text" @mouseenter="enter(4)">
            定制服务
          </div>
          <div class="navigation-text" @mouseenter="enter(5)">
            会员中心
          </div>
          <div class="navigation-text" @mouseenter="enter(6)">
            加入我们
          </div>
          <div class="navigation-text-select" v-show="selectShow" :class="selectShow ? 'selectShow' : ''">
            <div class="below"></div>
            <div class="sanjiao"></div>
            <div class="navigation-text-list">
              <div class="navigation-text-list-li" v-for="(item, index) in navigationList[num]" :key="index"
                @click="routerClick(item, index)">{{ item.title }} <img src="../../img/select2.png" alt=""></div>
            </div>
          </div>
        </div>
        <div class="searchbox" :class="searchShow ? '' : 'searchHover'">
          <div class="search">
            <input type="text" placeholder="输入关键词搜索商品" v-model="text" @focus="focusClick" />
          </div>
        </div>


        <div class="ser" @click="searchClick()" :class="searchShow ? '' : 'serHover'">
          <svg t="1677491131316" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="4550">
            <path
              d="M797.525333 752.266667c62.069333-72.736 97.28-165.002667 97.28-262.186667C894.816 266.528 713.621333 85.333333 490.08 85.333333 266.538667 85.333333 85.333333 266.538667 85.333333 490.069333 85.333333 713.610667 266.538667 894.826667 490.069333 894.826667a404.693333 404.693333 0 0 0 118.208-17.546667 32 32 0 0 0-18.666666-61.216 340.693333 340.693333 0 0 1-99.541334 14.762667C301.888 830.816 149.333333 678.261333 149.333333 490.069333 149.333333 301.888 301.888 149.333333 490.069333 149.333333 678.261333 149.333333 830.826667 301.888 830.826667 490.069333c0 89.28-35.381333 173.696-97.141334 237.322667a36.992 36.992 0 0 0 0.384 51.925333l149.973334 149.973334a32 32 0 0 0 45.258666-45.248L797.525333 752.266667z"
              p-id="4551" fill="#ffffff"></path>
          </svg>

        </div>
        <div class="searchClose" v-show="!searchShow" @click="searchShow = true">
          <svg t="1683706039357" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="4469" width="200" height="200">
            <path
              d="M512 456.310154L94.247385 38.557538a39.542154 39.542154 0 0 0-55.689847 0 39.266462 39.266462 0 0 0 0 55.689847L456.310154 512 38.557538 929.752615a39.542154 39.542154 0 0 0 0 55.689847 39.266462 39.266462 0 0 0 55.689847 0L512 567.689846l417.752615 417.752616c15.163077 15.163077 40.290462 15.36 55.689847 0a39.266462 39.266462 0 0 0 0-55.689847L567.689846 512 985.442462 94.247385a39.542154 39.542154 0 0 0 0-55.689847 39.266462 39.266462 0 0 0-55.689847 0L512 456.310154z"
              p-id="4470" fill="#ffffff"></path>
          </svg>
        </div>

        <div class="login" v-show="searchShow">
          <div class="loginDiv" v-show="loginShow">
            <div class="enter" @click="toLogin()" @mouseleave="enterLeave($event)"><span>登录</span>
              <div></div>
            </div>
            <div class="shu"><span>|</span></div>
            <div class="register" @click="register()" @mouseleave="enterLeave($event)"><span>注册</span>
              <div></div>
            </div>
          </div>
          <div class="user" @click="gouser" v-show="!loginShow">
            <img src="../../img/view.png" alt="">
          </div>
          <div>

          </div>
        </div>
        <div class="web" v-show="searchShow">
          <div class="web-search">
            <input type="text" name="" id="" v-model="text">
            <svg t="1677491131316" @click="websearch" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4550">
              <path
                d="M797.525333 752.266667c62.069333-72.736 97.28-165.002667 97.28-262.186667C894.816 266.528 713.621333 85.333333 490.08 85.333333 266.538667 85.333333 85.333333 266.538667 85.333333 490.069333 85.333333 713.610667 266.538667 894.826667 490.069333 894.826667a404.693333 404.693333 0 0 0 118.208-17.546667 32 32 0 0 0-18.666666-61.216 340.693333 340.693333 0 0 1-99.541334 14.762667C301.888 830.816 149.333333 678.261333 149.333333 490.069333 149.333333 301.888 301.888 149.333333 490.069333 149.333333 678.261333 149.333333 830.826667 301.888 830.826667 490.069333c0 89.28-35.381333 173.696-97.141334 237.322667a36.992 36.992 0 0 0 0.384 51.925333l149.973334 149.973334a32 32 0 0 0 45.258666-45.248L797.525333 752.266667z"
                p-id="4551" fill="#ffffff"></path>
            </svg>
          </div>
          <div class="shoop" @click="shoopClick({ path: 'myShoop' })">
            <img src="../../img/shoop1.png" alt="" />
          </div>
          <div class="menu">
            <div class="pcShow">MENU</div>
            <div @click.stop="column()" class="menuShow">
              <img src="../../img/Vector.png" alt="" />
            </div>
            <div class="hamburger" @click.stop="hamburgerClick()">
              <div class="hamburger-box">
                <div class="hamburger-inner1"></div>
                <div class="hamburger-inner2"></div>
                <div class="hamburger-inner3"></div>
              </div>
            </div>
          </div>

        </div>

        <div class="searchMore" v-show="!searchShow">

          <el-collapse-transition>
            <div class="search-container">
              <span v-for="(i, index) in arr" @click="product(i)" :key="index">{{ i }}</span>
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <div class="bigbox navigationShow" v-show="navigationShow" :class="searchShow ? '' : 'bigboxHover'">
        <div class="logo" @click=logo()>
          <img src="../../img/logo2.png" alt="" />
        </div>
        <div class="text" @mouseenter="navigationText($event)" @mouseleave="navigationTextLeave()" v-show="searchShow">
          <div class="navigation-text" @mouseenter="enter(0)">
            关于正熙

          </div>
          <div class="navigation-text" @mouseenter="enter(1)">
            产品中心
          </div>
          <div class="navigation-text" @mouseenter="enter(2)">
            学术园地
          </div>
          <div class="navigation-text" @mouseenter="enter(3)">
            资讯信息
          </div>
          <div class="navigation-text" @mouseenter="enter(4)">
            定制服务
          </div>
          <div class="navigation-text" @mouseenter="enter(5)">
            会员中心
          </div>
          <div class="navigation-text" @mouseenter="enter(6)">
            加入我们
          </div>
          <div class="navigation-text-select" v-show="selectShow" :class="selectShow ? 'selectShow' : ''">
            <div class="below"></div>
            <div class="sanjiao"></div>
            <div class="navigation-text-list">
              <div class="navigation-text-list-li" v-for="(item, index) in navigationList[num]" :key="index"
                @click="routerClick(item, index)">{{ item.title }}<img src="../../img/select.png" alt=""></div>
            </div>

          </div>
        </div>

        <div class="searchbox" :class="searchShow ? '' : 'searchHover'">
          <div class="search">
            <input type="text" placeholder="输入关键词搜索商品" v-model="text" @focus="focusClick" />
          </div>
          <div class="searchMore" v-show="!searchShow">

            <el-collapse-transition>
              <div class="search-container">
                <span v-for="(i, index) in arr" @click="product(i)" :key="index">{{ i }}</span>

              </div>
            </el-collapse-transition>
          </div>
        </div>
        <div class="ser" @click="searchClick()" :class="searchShow ? '' : 'serHover'">

          <svg t="1693447826953" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="4384">
            <path
              d="M797.525333 752.266667c62.069333-72.736 97.28-165.002667 97.28-262.186667C894.816 266.528 713.621333 85.333333 490.08 85.333333 266.538667 85.333333 85.333333 266.538667 85.333333 490.069333 85.333333 713.610667 266.538667 894.826667 490.069333 894.826667a404.693333 404.693333 0 0 0 118.208-17.546667 32 32 0 0 0-18.666666-61.216 340.693333 340.693333 0 0 1-99.541334 14.762667C301.888 830.816 149.333333 678.261333 149.333333 490.069333 149.333333 301.888 301.888 149.333333 490.069333 149.333333 678.261333 149.333333 830.826667 301.888 830.826667 490.069333c0 89.28-35.381333 173.696-97.141334 237.322667a36.992 36.992 0 0 0 0.384 51.925333l149.973334 149.973334a32 32 0 0 0 45.258666-45.248L797.525333 752.266667z"
              p-id="4385"></path>
          </svg>
        </div>
        <div class="searchClose" v-show="!searchShow" @click="searchShow = true">
          <svg t="1693448401199" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="4538">
            <path
              d="M813.653333 802.986667a42.666667 42.666667 0 0 1-60.373333 0L512 561.706667 270.72 802.986667a42.666667 42.666667 0 1 1-60.373333-60.373334L451.626667 501.333333 210.346667 260.053333a42.666667 42.666667 0 0 1 30.293333-72.746666 42.666667 42.666667 0 0 1 30.08 12.373333L512 440.96 753.28 199.68a42.666667 42.666667 0 0 1 72.746667 30.293333 42.666667 42.666667 0 0 1-12.373334 30.08L572.373333 501.333333l241.28 241.28a42.666667 42.666667 0 0 1 0 60.373334z"
              p-id="4539"></path>
          </svg>
        </div>
        <div class="login" v-show="searchShow">
          <div class="loginDiv" v-show="loginShow">
            <div class="enter" @click="toLogin()" @mouseleave="enterLeave($event)"><span>登录</span>
              <div></div>
            </div>
            <div class="shu"><span>|</span></div>
            <div class="register" @click="register()" @mouseleave="enterLeave($event)"><span>注册</span>
              <div></div>
            </div>
          </div>
          <div class="user" @click="gouser" v-show="!loginShow">
            <img src="../../img/view.png" alt="">
          </div>
        </div>
        <div class="web" v-show="searchShow">
          <div class="web-search">
            <input type="text" name="" id="" v-model="text">
            <svg t="1677491131316" class="icon" @click="websearch" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4550">
              <path
                d="M797.525333 752.266667c62.069333-72.736 97.28-165.002667 97.28-262.186667C894.816 266.528 713.621333 85.333333 490.08 85.333333 266.538667 85.333333 85.333333 266.538667 85.333333 490.069333 85.333333 713.610667 266.538667 894.826667 490.069333 894.826667a404.693333 404.693333 0 0 0 118.208-17.546667 32 32 0 0 0-18.666666-61.216 340.693333 340.693333 0 0 1-99.541334 14.762667C301.888 830.816 149.333333 678.261333 149.333333 490.069333 149.333333 301.888 301.888 149.333333 490.069333 149.333333 678.261333 149.333333 830.826667 301.888 830.826667 490.069333c0 89.28-35.381333 173.696-97.141334 237.322667a36.992 36.992 0 0 0 0.384 51.925333l149.973334 149.973334a32 32 0 0 0 45.258666-45.248L797.525333 752.266667z"
                p-id="4551" fill="#ffffff"></path>
            </svg>
          </div>
          <div class="shoop" @click="shoopClick({ path: 'myShoop' })">
            <img src="../../img/shoop2.png" alt="" />
          </div>
          <div class="menu">
            <div class="pcShow">MENU</div>
            <div class="menuShow" @click.stop="column()">
              <img src="../../img/Vector2.png" alt="" />
            </div>
            <div class="hamburger" @click.stop="hamburgerClick()">
              <div class="hamburger-box">
                <div class="hamburger-inner1"></div>
                <div class="hamburger-inner2"></div>
                <div class="hamburger-inner3"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="head-column">
        <div class="wrap" :class="titleNum == 0 ? 'titleHover' : ''">
          <div class="wrap-title" @click="titleClick()">
            <div class="wrap-title-left">主栏目</div>
            <div class="wrpa-title-middle"></div>
            <div class="wrap-title-right">
              <div class="zhankai">
                <span>展开</span>
                <div class="zhankai-select">
                  <img src="../../img/select.png" alt="">
                </div>
              </div>
              <div class="shousuo">
                <span>收缩</span>
                <div class="zhankai-select">
                  <img src="../../img/select.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <el-collapse-transition>
            <div v-show="titleNum == 0">
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum == 0 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick(0)">
                    <span>关于正熙</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum == 0">
                      <div v-for="(i, index) in navigationList[0]" @click="click(i)" :key="index">{{ i.title }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum == 1 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick(1)">
                    <span>产品中心</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum == 1">
                      <div v-for="(i, index) in navigationList[1]" @click="click(i, index)" :key="index">{{ i.title }}
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum == 2 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick(2)">
                    <span>学术园地</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum == 2">
                      <div v-for="(i, index) in navigationList[2]" @click="click(i)" :key="index">{{ i.title }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum == 3 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick(3)">
                    <span>资讯信息</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum == 3">
                      <div v-for="(i, index) in navigationList[3]" @click="click(i)" :key="index">{{ i.title }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum == 4 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick(4)">
                    <span>加入我们</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum == 4">
                      <div v-for="(i, index) in navigationList[6]" @click="click(i)" :key="index">{{ i.title }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="wrap" :class="titleNum == 1 ? 'titleHover' : ''">
          <div class="wrap-title" @click=titleClick()>
            <div class="wrap-title-left">副栏目</div>
            <div class="wrpa-title-middle"></div>
            <div class="wrap-title-right">
              <div class="zhankai">
                <span>展开</span>
                <div class="zhankai-select">
                  <img src="../../img/select.png" alt="">
                </div>
              </div>
              <div class="shousuo">
                <span>收缩</span>
                <div class="zhankai-select">
                  <img src="../../img/select.png" alt="">
                </div>
              </div>
            </div>
          </div>
          <el-collapse-transition>
            <div v-show="titleNum == 1">
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum2 == 0 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick2(0)">
                    <span>定制服务</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum2 == 0">
                      <div v-for="(i, index) in navigationList[4]" @click="click(i)" :key="index">{{ i.title }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum2 == 1 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick2(1)">
                    <span>会员中心</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum2 == 1">
                      <div v-for="(i, index) in navigationList[5]" @click="click(i)" :key="index">{{ i.title }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum2 == 2 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick2(2)">
                    <span>购物指南</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum2 == 2">
                      <div v-for="(i, index) in footerList[1]" @click="click(i)" :key="index">{{ i.name }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum2 == 3 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick2(3)">
                    <span>配送政策</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum2 == 3">
                      <div v-for="(i, index) in footerList[2]" @click="click(i)" :key="index">{{ i.name }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
              <div class="column-banner-main">
                <div class="column-banner-container" :class="textNum2 == 4 ? 'wrapHover' : ''">
                  <div class="column-text" @click="textClick2(4)">
                    <span>售后服务</span>
                    <div class="column-hamburger">
                      <div class="column-inner1"></div>
                      <div class="column-inner2"></div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <div class="c-t-c-b" v-show="textNum2 == 4">
                      <div v-for="(i, index) in footerList[3]" @click="click(i)" :key="index">{{ i.name }}</div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="web-login" v-show="loginShow">
          <div @click="toLogin()">登录</div>
          <div @click="register()">注册</div>
        </div>
        <div class="web-user" @click="gowebuser" v-show="!loginShow">
          <img src="../../img/view.png" alt="">
          <span>{{ username }}</span>
        </div>
      </div>
    </div>

    <column :class="[columnShow ? 'columnShow' : '']" class="column" @closeColumn=closeColumn @footer2="footerChange">
    </column>
    <router-view @homechange="homechange" @footer2="footerChange"></router-view>
    <footerVue v-show="footerShow" />
  </div>
</template>

<script>

import { ref } from 'vue';
import { useRoute } from 'vue-router';
import bannerVue from "../banner/banner.vue";
import footerVue from "../footer/footer.vue";
import mainVue from "../main/main.vue";
import column from "../column/column.vue"
import { system, hot_search, cate_list, user_info } from '../../request/api'
export default {
  name: "navigation",
  components: {
    mainVue,
    footerVue,
    bannerVue,
    column
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      show: "register",
      navigationShow: false,
      wrapperShow: false,
      data: '',
      searchShow: true,
      imgurl: 'https://admin.zxbiotech.cn',
      n: "01",
      textNum: -1,
      titleNum: 0,
      textNum2: -1,
      homeShow: true,
      footerShow: true,
      navigationList: [
        [
          {
            title: '正熙简介',
            path: 'Introduction'
          }, {
            title: '核心团队',
            path: 'Team'
          },
          {
            title: '联系方式',
            path: 'Contact'
          }, {
            title: '意见反馈',
            path: 'Opinion'
          },
        ], [

          {
            name: '一抗',
            path: 'Primary'
          }, {
            name: '二抗',
            path: 'Secondary'
          },
          {
            name: '同行对照',
            path: 'Homologous'
          }, {
            name: '重组蛋白',
            path: 'Recombinant'
          }, {
            name: '整段抗体',
            path: 'Whole'
          }
        ], [

          {
            title: '应用领域',
            path: 'APPlication'
          }, {
            title: '文献资料',
            path: 'Reference'
          },
          {
            title: '技术资料',
            path: 'Technical'
          }, {
            title: '视频课堂',
            path: 'Video'
          }
        ],
        [

          {
            title: '正熙公告',
            path: 'announcement'
          },
          {
            title: '行业资讯',
            path: 'industry'
          },
        ],
        [

          {
            title: '定制申请表',
            path: 'customize'
          }
        ],
        [

          {
            title: '积分商城',
            path: 'Mall'
          }, {
            title: '会员说明',
            path: 'Description'
          },
          {
            title: '隐私政策',
            path: 'Privacy'
          }, {
            title: '账号服务条款',
            path: 'Clause'
          }
        ],
        [
          {
            title: '招商代理',
            path: 'InvestmentAgent'
          }, {
            title: '人才招聘',
            path: 'TalentRecruitment'
          }
        ],
      ],
      footerList: [
        [

          {
            name: '积分商城',
            path: 'Mall'
          }, {
            name: '会员说明',
            path: 'Description'
          },
          {
            name: '隐私政策',
            path: 'Privacy'
          }, {
            name: '账号服务条款',
            path: 'Clause'
          }
        ],
        [{
          name: '付款方式',
          path: 'Termsofpayment'
        },
        {
          name: '购买流程',
          path: 'Purchaseprocess'
        },
        {
          name: '订单处理',
          path: 'Orderprocessing'
        },
        {
          name: '常见问题',
          path: 'Shoppingproblem'
        },],
        [
          {
            name: '配送说明',
            path: 'Distributioninstructions'
          },

          {
            name: '验货签收',
            path: 'Checkandreceive'
          },
          {
            name: '常见问题',
            path: 'Q&A'
          },
        ],
        [{
          name: '退还/换货',
          path: 'Returngoods'
        },
        {
          name: '退款说明',
          path: 'Refundinstructions'
        },
        {
          name: '发票说明',
          path: 'Invoicespecification'
        },
        {
          name: '售后联系方式',
          path: 'Aftersalescontact'
        },
        ],

      ],
      selectShow: false,
      num: 0,
      columnShow: false,
      arr: '',
      text: '',
      productList: '',
      loginShow: true,
      username: '',
    };
  },
  mounted() {
    if (sessionStorage.getItem('id')) {


      this.loginShow = false
      user_info({ user_id: sessionStorage.getItem('id') }).then((res) => {
        this.username = res.data.data.phone
      })
    } else {

      this.loginShow = true
    }
    system({ id: 1 }).then((res) => {
      this.data = res.data.data
    })
    hot_search().then((res) => {
      this.arr = res.data.data
    })
    cate_list({ type: 9 }).then((res) => {
      this.navigationList[1] = res.data.data

    })
    var test = (this.$route.path);
    test = test.split('/')[1]
    if (test == 'myShoop') {
      this.footerShow = false
    } else {
      this.homeShow = false
      this.footerShow = true
    }
    if (test == 'Primary' || test == 'Secondary' || test == 'Homologous' || test == 'Recombinant' || test == 'Whole' || test == 'myShoop' || test == 'userorder' || test == 'usershoopcar' || test == 'userinvoice' || test == 'userintegral' || test == 'userexchange' || test == 'usercustomize' || test == 'usercollect' || test == 'useraddress' || test == 'productIndex' || test == 'webUser' || test == 'webuserorder' || test == 'webshezhi' || test == 'webaddress' || test == 'webintegral' || test == 'webshoopcar' || test == 'webcustomize' || test == 'product') {
      this.navigationShow = true;
    } else {

      this.navigationShow = false;
    }
    window.addEventListener("scroll", this.scrollLoadMore);
    this.preventScoll(false)
  },
  methods: {
    gowebuser() {
      this.navigationShow = true
      this.$router.push('webUser')
    },
    gouser() {
      this.$router.push('user')
      this.navigationShow = true;
    },
    product(i) {
      this.$router.push('product')
      sessionStorage.setItem('product', JSON.stringify({ title: i }))
      this.$store.commit('saveCurrDbSource', { title: i })
      this.searchShow = true
    },
    websearch() {
      if (this.text) {
        sessionStorage.setItem('product', JSON.stringify({ title: this.text }))
        this.$store.commit('saveCurrDbSource', { title: this.text })
        this.$router.push('product')
        this.text = ''
      }
    }, focusClick() {
      console.log(this.searchShow);

      if (this.searchShow == true) {
        this.searchShow = false
      }
    },
    searchClick() {
      if (this.searchShow == false) {
        let productList = JSON.parse(sessionStorage.getItem('product'))
        if (productList) {
          if (productList.title) {

            productList = {}
            productList.title = this.text
          } else {
            productList = {}
            productList.title = this.text
          }
        } else {
          productList = {}
          productList.title = this.text
        }

        sessionStorage.setItem('product', JSON.stringify(productList))
        this.$store.commit('saveCurrDbSource', productList)
        this.$router.push('product')
        this.searchShow = true
        this.text = ''
      } else {
        this.searchShow = false
      }
    },
    footerChange() {
      this.footerShow = true
    },
    click(val, index) {
      this.preventScoll(false)
      var test = (this.$route.path);
      test = test.split('/')[1]
      if (test == val) {
      } else {
        if (index + 1) {
          sessionStorage.setItem('product', JSON.stringify({ product_type: val.title }))
          this.$store.commit('saveCurrDbSource', ({ product_type: val.title }))
          this.$router.push('product')
        } else {
          this.$router.push(val.path)
        }
        this.footerShow = true
        this.homeShow = false
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        sessionStorage.setItem('getMenu', val.path)
        this.getMenu = val.path;
      }
      if (val == 'Primary' || val == 'Secondary' || val == 'Homologous' || val == 'Recombinant' || val == 'Whole' || val == 'myShoop' || val == 'productIndex' || val == 'product') {
        this.navigationShow = true;
      } else {
        this.navigationShow = false;
      }
      let hamburger = document.querySelectorAll('.hamburger')
      let head = document.querySelector('.headBox')
      let hamburgerHover1 = document.querySelectorAll('.hamburgerHover')
      let column = document.querySelector('.head-column')
      if (hamburgerHover1.length == 0) {
        hamburger[0].classList.add('hamburgerHover')
        hamburger[1].classList.add('hamburgerHover')
        column.classList.add('head-columnHover')
        head.classList.add('headHover')
      } else {
        hamburger[0].classList.remove('hamburgerHover')
        hamburger[1].classList.remove('hamburgerHover')
        head.classList.remove('headHover')
        column.classList.remove('head-columnHover')
      }

    },
    titleClick() {
      if (this.titleNum == 0) {
        this.titleNum = 1
      } else {
        this.titleNum = 0
      }
    },
    textClick2(n) {
      if (this.textNum2 == n) {
        this.textNum2 = -1
      } else {
        this.textNum2 = n
      }
    },
    textClick(n) {
      if (this.textNum == n) {
        this.textNum = -1
      } else {
        this.textNum = n
      }
    },
    hamburgerClick() {
      let hamburger = document.querySelectorAll('.hamburger')
      let head = document.querySelector('.headBox')
      let hamburgerHover1 = document.querySelectorAll('.hamburgerHover')
      let column = document.querySelector('.head-column')
      if (hamburgerHover1.length == 0) {
        hamburger[0].classList.add('hamburgerHover')
        hamburger[1].classList.add('hamburgerHover')
        column.classList.add('head-columnHover')
        head.classList.add('headHover')
        this.preventScoll(true)
      } else {
        hamburger[0].classList.remove('hamburgerHover')
        hamburger[1].classList.remove('hamburgerHover')
        head.classList.remove('headHover')
        column.classList.remove('head-columnHover')
        this.preventScoll(false)
      }
    },
    enterLeave(e) {
      let div = (e.target.children[1]);
      div.classList.add('enterleave')
      setTimeout((() => {
        div.classList.remove('enterleave')
      }), 300)
    },
    //滚动监听
    homechange(val) {
      val = val - 1
      if (val == 0 || val == 6) {
        this.navigationShow = false
      } else {
        this.navigationShow = true
      }
      if (val == 6) {
        this.homeshow = false
      } else {
        this.home = true
      }
      if (val == 0) {
        this.wrapperShow = false
      } else {
        this.wrapperShow = true
      }
    },
    scrollLoadMore() {
      let scrollWrap = document.querySelector('.box');
      var currentScrollTop = scrollWrap.scrollTop;
      var currentOffsetHeight = scrollWrap.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      let bigboxScroll = document.querySelector(".bigbox");
      let containerScroll = document.querySelector(".container");
      if (containerScroll) {
      } else {
        return
      }
      let topScroll = bigboxScroll.offsetHeight + containerScroll.offsetHeight;
      if (scrollTop == currentOffsetHeight - 66 - topScroll || scrollTop > currentOffsetHeight - 66 - topScroll) {
        this.navigationShow = false;
        this.homeShow = false
      } else if (scrollTop > topScroll - 81 || scrollTop == topScroll - 81) {
        this.navigationShow = true;
        this.homeShow = true
        var test = window.location.hash;
        test = test.slice(2)
        if (test == 'Home') { this.homeShow = true } else {
          this.homeShow = false
        }
      } else {
        if (scrollTop == 0) {
        } else {
          this.homeShow = false
          this.navigationShow = false;
        }
        var test = window.location.hash;
        test = test.slice(2)
        if (test == 'Home') { this.homeShow = true } else {
          this.homeShow = false
        }
      }
      if (
        scrollTop > containerScroll.offsetHeight / 2 ||
        scrollTop == containerScroll.offsetHeight / 2
      ) {
        this.wrapperShow = true;
      } else {
        this.wrapperShow = false;
        this.n = "01";
      }
    },
    //栏目
    column() {
      this.preventScoll(true)
      this.columnShow = true
      let column = document.querySelector('.column')
      column.style.visibility = "visible";
    },

    closeColumn(val) {
      this.preventScoll(false)
      this.columnShow = val
    },
    preventScoll(flag) {
      if (flag) {
        const top = document.documentElement.scrollTop || document.body.scrollTop;
        const column = document.querySelector('.column')
        let dom = document.getElementById("app");
        column.style.top = top + 'px'
        document.body.style.cssText += `
            position: fixed;
            left: 0;
            top: ${-top}px;
        `
      } else {
        const top = document.body.style.top;
        let dom = document.getElementById("app");
        dom.style.width = "100%";
        document.body.style.cssText += `
            position: static;
        `;
        window.scrollTo(0, Math.abs(parseFloat(top)))
      }
    },

    //logo
    logo() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$router.push('/Home')
      this.homeShow = true
      this.footerShow = true
      this.navigationShow = false
    },
    //登录
    toLogin() {
      this.show = "login";
      /*   this.$bus.$emit('registerEvent',this.show) */
      this.$router.push({ path: "/Login", query: { show: "toLogin" } });
      this.preventScoll(false)
    },
    //注册
    register() {
      this.show = "register";
      /*  this.$bus.$emit('registerEvent',this.show) */
      this.$router.push({ path: "/Login", query: { show: this.show } });
      this.preventScoll(false)
    },
    //导航栏
    navigationText(event, val) {
      this.selectShow = true
    },
    navigationTextLeave() {
      this.selectShow = false
    },
    enter(n) {
      let navigation = document.querySelectorAll('.navigation-text-select')
      navigation[0].style.left = 0.8875 + 1.757 * n + 'rem'
      navigation[0].style.transition = "left .5s ease"
      this.num = n
      navigation[1].style.left = 0.8875 + 1.757 * n + 'rem'
      navigation[1].style.transition = "left .5s ease"
    },
    shoopClick(val) {
      var test = window.location.hash;
      test = test.slice(2)
      if (test == 'myShoop') {
      } else {
        this.navigationShow = true
        this.footerShow = false
        this.$router.push('myShoop')
      }
    },
    routerClick(val, index) {
      this.footerShow = true
      this.homeShow = false
      var test = (this.$route.path);
      test = test.split('/')[1]
      if (val.path == 'Primary' || val.path == 'Secondary' || val.path == 'Homologous' || val.path == 'Recombinant' || val.path == 'Whole' || val.path == 'myShoop' || test.path == 'product') {
        this.navigationShow = true;
      } else {
        this.navigationShow = false;
      }
      if (test == val.path) {
      } else if (this.num != 1) {
        this.$router.push(val.path);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        sessionStorage.setItem('getMenu', val.path)
        this.getMenu = val.path;
        this.footerShow = true
        this.$submit.direct(val.path);
        sessionStorage.removeItem('product')
      } else if (this.num == 1) {
        this.navigationShow = true;
        sessionStorage.setItem('product', JSON.stringify({ product_type: val.title }))
        this.$store.commit('saveCurrDbSource', JSON.stringify({ product_type: val.title }))
        this.$router.push('product')



      }




    }
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 300px) and (max-width: 820px) {
  .headHover .web-search {
    display: none !important;
  }

  .web-user img {
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    margin-right: 1rem;
  }

  .web-user {
    display: flex;
    align-items: center;
  }

  .web-user span {
    font-size: 16px;
    color: #144297;
  }

  .pcShow {
    display: none !important;
  }

  .web-login {
    display: flex;
    font-size: 16px;
    color: #144297;
    justify-content: space-around;
  }

  .headHover .web-search {
    display: none;
  }

  .web-search {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 1rem;
    padding-right: 0.5rem;
    margin-left: 0.5rem;
    width: 6rem;
  }

  .navigationShow .web-search {
    background: rgba(217, 227, 239, 0.4);
  }

  .web-search input {

    background: transparent;
    border: 0;
    outline: none;
    width: 6rem;
    padding-left: 0.25rem;
    font-size: 14px;
    width: 4.5rem;
  }

  .web-search svg {
    height: 1rem;
    width: 1rem;
  }

  .ser {
    display: none;
  }

  .wrap {
    margin-bottom: 40px;
  }

  .titleHover .shousuo {
    display: flex !important;
  }

  .titleHover .zhankai {
    display: none !important;
  }

  .shousuo {
    display: none;
    align-items: center;
  }

  .shousuo .zhankai-select {
    transform: rotate(180deg);
  }

  .wrapHover .column-inner2 {
    background: transparent !important;
    transition: all .3s ease;
  }

  .column-hamburger {
    position: relative;
    height: 20px;
    width: 20px;
  }

  .c-t-c-b {
    padding-bottom: 20px;
  }

  .c-t-c-b div {
    line-height: 40px;
    font-size: 16px;
    font-family: 'Alibaba PuHuiTi-Regular';
    font-weight: 400;
    color: #4368AC;
  }

  .column-inner1 {
    width: 1px;
    height: 20px;
    background: #144297;
    transform: rotate(90deg);
    position: absolute;
    left: 9.5px;
    top: 0
  }

  .column-inner2 {
    width: 1px;
    height: 20px;
    background: #144297;
    margin-left: 9.5px;
  }

  .column-text {
    font-size: 18px;
    color: #144297;
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px dashed #144297;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-family: 'Alibaba PuHuiTi-Medium';
  }

  .zhankai {
    display: flex;
    align-items: center;
  }

  .zhankai-select {
    margin-left: 5px;
    height: 20px;
    width: 20px;
    border-radius: 20px;

    background: rgba(217, 227, 239, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .zhankai-select img {
    height: 15px;
    width: 15px;
  }

  .wrap-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .wrpa-title-middle {
    width: 60%;
    height: 1px;
    background: #144297;
  }

  .head-column {
    padding-top: 100px;
    width: 90%;
    margin: 40px auto 0;
    opacity: 0;
    transition: all .7s ease;
  }

  .head-columnHover {
    opacity: 1 !important;
    margin: 0 auto !important;
  }

  .wrap-title {
    font-size: 16px;
    color:
      rgba(50, 123, 233, 1);
  }

  .headHover {

    height: 100vh !important;
    background: #F3F5F8;
    width: 100%;

  }

  .headHover .logo1 {
    display: none;
  }

  .headHover .logo2 {
    display: block;
  }

  .logo2 {
    display: none;
  }

  .headHover .shoop {
    display: none;
  }

  .menu:hover {
    background: rgba(217, 227, 239, 0.4) !important;
  }

  .headBox {
    position: absolute;
    z-index: 1000 !important;
    height: 60px;
    transition: all.3s ease;
    width: 100%;
    overflow: hidden;
  }

  .hamburger-box {
    position: relative;
    width: 19px;
    height: 15px;
    display: block;
  }

  .headHover .menu {
    color: #333333;
    background: rgba(217, 227, 239, 0.4);
  }

  .navigationShow .hamburger-inner1 {
    background: #144297;
  }

  .navigationShow .hamburger-inner2 {
    background: #144297;
  }

  .navigationShow .hamburger-inner3 {
    background: #144297;
  }

  .hamburgerHover .hamburger-inner1 {

    transform: translate3d(0, 6.5px, 0) rotateZ(45deg) rotateX(0) rotateY(0);
    -webkit-transform: translate3d(0, 6.5px, 0) rotateZ(45deg) rotateX(0) rotateY(0);
    background: #144297;
    overflow: hidden;
  }

  .hamburgerHover .hamburger-inner2 {
    background: transparent;

  }

  .hamburgerHover .hamburger-inner3 {
    background: #144297;
    transform: translate3d(0, -6.5px, 0) rotateZ(-45deg) rotateX(0) rotateY(0);
    -webkit-transform: translate3d(0, -6.5px, 0) rotateZ(-45deg) rotateX(0) rotateY(0);
    overflow: hidden;
  }

  /*  .hamburgerHover{
  transition: transform 0.6s 0s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0.5s 0s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  transform: translate3d(0,0,0) rotateY(-180deg) rotateX(0)  rotateZ(0) !important;
  -webkit-transform:translate3d(0,0,0) rotateY(-180deg) rotateX(0)  rotateZ(0) !important;
  overflow: hidden;
 } */
  .hamburger-inner {
    transition: transform 0.6s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0.5s 0s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
    width: 19px;
    height: 2px;
    background: #fff;
    position: absolute;
  }

  .hamburger-inner1 {
    top: 0;
    left: 0;
    width: 19px;
    height: 2px;
    position: absolute;
    background: #fff;
    transition: transform 0.6s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0.5s 0s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  }

  .hamburger-inner2 {
    width: 19px;
    height: 2px;
    background: #fff;
    transition: transform 0.6s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0.5s 0s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  }

  .hamburger-inner3 {
    bottom: 0;
    left: 0;
    position: absolute;
    width: 19px;
    height: 2px;
    background: #fff;
    transition: transform 0.6s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0.5s 0s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
  }

  .hamburger {
    display: inline-block;
    cursor: pointer;
    transition-property: opacity, filter;
    transition-duration: 0.15s;
    transition-timing-function: linear;
    font: inherit;
    color: inherit;
    text-transform: none;
    background-color: transparent;
    border: 0;
    margin: 0;
    overflow: visible;
    transition: transform 0.6s 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background-color 0.5s 0s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .menuShow {
    display: none !important;
  }

  .web {
    display: flex;
    padding-right: 10px;
  }

  .text {
    display: none !important;
  }

  .search {
    display: none !important;
  }

  .logo {
    height: 2.2rem !important;
    width: auto !important;
    margin-left: 10px !important;
  }

  .bigbox {
    height: 60px !important;
    justify-content: space-between;

  }

  .login {
    width: auto !important;
    font-size: 12px !important;
    display: none !important;
  }

  .shu {
    margin-left: 5px;
    margin-right: 5px;
  }

  .shoop {
    height: 40px !important;
    width: 40px !important;
    border-radius: 40px !important;
  }

  .shoop img {
    height: 18px !important;
    width: 18px !important;
  }

  .menu {
    height: auto !important;
    width: auto !important;
    padding-left: 14px !important;
    padding-right: 14px !important;
    padding-top: 9px !important;
    padding-bottom: 9px !important;
    margin-right: 10px !important;
  }

  .menu div {
    align-items: center;
  }

  .menu img {
    width: 12px !important;
    height: 10px !important;
  }

  .menu div:nth-child(1) {
    margin-right: 5px;
    font-size: 16px !important;
  }
}

@media screen and (min-width: 820px) {
  .navigationShow .search-container span {
    color: #144297;
  }

  .bigboxHover {
    height: 3.6rem !important;
    align-items: start !important;
  }

  .searchMore {
    position: absolute;
    left: 0;
    top: 1rem;
    overflow: hidden;
  }

  .searchbox {
    overflow: hidden;
    height: 1rem;
    background: linear-gradient(to right, #fff, #fff) no-repeat right bottom;
    background-size: 0 1px;
    transition: background-size .5s ease;
    margin-left: 1.1625rem;
  }

  .searchHover {

    width: 9.8375rem !important;

    background-size: 100% 1px !important;

  }

  .navigationShow .searchHover .search {
    background: none;
  }

  .text {
    height: 1rem !important;
  }

  .search-container {
    height: 2.6rem;
    width: auto;
    padding-top: 0.375rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-left: 3.2rem;
    animation: searchDonghua .7s ease
  }

  .bigbox {
    transition: all .5s ease;
    align-items: start !important;
  }

  .search-container span {
    font-size: 0.225rem;
    padding-bottom: 16px;
    line-height: 0.2625rem;
    font-family: 'Alibaba PuHuiTi-Regular';
    font-weight: 400;
    color: #FFFFFF;
    -webkit-background-clip: text;

  }

  .ser {
    top: 0.4rem;
  }

  .searchClose {
    top: 0.4rem;
  }

  .searchHover input {
    background: none !important;
    padding-left: 0 !important;
    animation: searchDonghua .7s ease
  }

  @keyframes searchDonghua {
    0% {
      transform: translateX(-30px);
      opacity: 0;
    }

    100% {
      transform: translateX(0px);
      opacity: 1;
    }
  }

  .serHover {
    right: 10.7rem !important;
  }
}

.pcShow {
  display: block;
}

.web-search {
  display: none;
}

.user {
  height: 0.5rem;
  width: 0.5rem;
  border-radius: .5rem;
  border: 4px solid rgba(255, 255, 255, 0.2);
}

.user:hover {
  cursor: pointer;
}

.navigationShow .user {
  border: 4px solid rgba(217, 227, 239, 0.4);
}

.user img {
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 0.5rem;
}

.loginDiv {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.search-container span:hover {
  cursor: pointer;
}

.hamburger {
  display: none;
}

.shoop:hover {
  background: rgba(255, 255, 255, 0.4);
}

.menu:hover {
  background: rgba(255, 255, 255, 0.4);
}

.navigationShow .register div {
  width: 100%;
  height: 1px;
  background: #144297;
  margin-left: -100%;
  transition: all .3s ease;
}

.logo2 {
  display: none;
}

.headBox {
  height: 1rem;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}

.navigationShow .enter div {
  width: 100%;
  height: 1px;
  background: #144297;
  margin-left: -100%;
  transition: all .3s ease;
}

.enter {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: content-box;
  overflow: hidden;

}

.register {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: content-box;
  overflow: hidden;

}

.enterleave {
  animation: donghua2 .3s;
}

@keyframes donghua2 {
  from {
    margin-left: 0;
  }

  to {
    margin-left: 100%;
  }
}

.register span {
  padding-bottom: 4px;
  font-family: 'Alibaba PuHuiTi-Regular';
}

.register div {
  width: 100%;
  height: 1px;
  background: #fff;
  margin-left: -100%;
  transition: all .3s ease;
}

.enter span {
  padding-bottom: 4px;
  font-family: 'Alibaba PuHuiTi-Regular';
}

.register:hover div {
  margin-left: 0 !important;

}

.enter div {
  width: 100%;
  height: 1px;
  background: #fff;
  margin-left: -100%;
  transition: all .3s ease;
}

.enter:hover div {
  margin-left: 0 !important;

}

.shu {
  padding-bottom: 5px;
}

.navigation-text-list-li img {
  transform: rotate(-90deg);
  height: 0px;
  width: 0px;

  transition: all .3s ease;
}

.navigation-text-list-li:hover img {

  height: 15px;
  width: 15px;

}

.navigation-text {
  font-size: 0.225rem;
}

.menu div {
  font-family: 'Alibaba PuHuiTi-Regular';
}

.shoop:hover {
  cursor: pointer;
}

.box {
  position: relative;
}

.column {
  position: absolute;

  z-index: 9999;
  visibility: hidden;
  right: -100%;
  transition: right 0.5s ease;
}

.columnFalse {
  transition: all 1s linear;

}

@-webkit-keyframes lanmu2 {
  0% {
    right: 0;
  }

  100% {
    right: -100%;
  }
}

.columnShow {
  right: 0;

}

@-webkit-keyframes lanmu {
  0% {
    right: -100%;
  }

  100% {
    right: 0;
  }
}

.navigation-text-list-li:hover {
  cursor: pointer;
}

.navigation-text-list-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.navigation-text-list-li span {
  display: none;
}

.navigation-text-list-li:hover span {
  display: block;
}

.below {
  position: absolute;
  top: 0;
  left: 0;
  width: 0.8875rem;
  height: 2px;
  background: #fff;
}

.selectShow {

  -webkit-animation: donghua .3s ease;
  transform-origin: 0 0;
}

@-webkit-keyframes donghua {
  0% {
    transform: scale(1, 0);
  }

  100% {
    transform: scale(1, 1);
  }
}

.wrapper-num {
  position: absolute;
  bottom: -0.05rem;
  left: -0.05rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.5rem;
  width: 0.5rem;
  color: #fff;
}

.navigationShow .wrapper-num {
  color: #144297;
}

.circleProgress_wrapper {
  width: 0.5rem;
  height: 0.5rem;

  position: fixed;
  border: 0.05rem solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  left: 0.375rem;
  top: 6.4375rem;
  box-sizing: border-box;
  z-index: 9999;
}

.wrapper {
  width: 0.3rem;
  height: 0.5rem;
  position: absolute;
  top: -0.05rem;
  overflow: hidden;
}

.right {
  right: -0.05rem;
  transform-origin: (0%, 50%);
}

.left {
  left: -0.05rem;
}

.rightcircle {
  border: 0.05rem solid transparent;
  border-top: 0.05rem solid #ffffff;
  border-right: 0.05rem solid #ffffff;
  position: absolute;
  right: 0;
  -webkit-animation: circleProgressLoad_right 5s linear infinite;
}

.leftcircle {
  display: flex;
  border: 0.05rem solid transparent;
  border-bottom: 0.05rem solid #ffffff;
  border-left: 0.05rem solid #ffffff;
  position: absolute;
  left: 0;
  -webkit-animation: circleProgressLoad_left 5s linear infinite;
}

.circleProgress {
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  -webkit-transform: rotate(-90deg);
}

.circleProgress2 {
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-transform: rotate(210deg);
}

.circleProgress3 {
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-transform: rotate(210deg);
}

.wrapperShow {
  border: 0.05rem solid rgba(20, 66, 151, 0.1);
}

.navigationShow .navigation-text-list {

  background: #fff;





}

.navigationShow .sanjiao {

  border-bottom: 0.1rem solid #fff;
}

.navigationShow .below {
  background: #144297 0%;
}

.navigationShow .circleProgress_wrapper {
  width: 0.5rem;
  height: 0.5rem;

  position: absolute;
  border: 0.05rem solid rgba(20, 66, 151, 0.1);
  border-radius: 50%;
  left: 0.375rem;
  top: 6.4375rem;
  box-sizing: border-box;
}

.navigationShow .wrapper {
  width: 0.3rem;
  height: 0.5rem;
  position: absolute;
  top: -0.05rem;
  overflow: hidden;
}

.navigationShow .right {
  right: -0.05rem;
  /*   transform-origin:0% 50%; */
  /*  transform: rotate(180deg); */
}

.navigationShow .left {
  left: -0.05rem;
}

.navigationShow .rightcircle {
  border: 0.05rem solid transparent;
  border-top: 0.05rem solid #144297;
  border-right: 0.05rem solid #144297;
  position: absolute;
  right: 0;
  -webkit-animation: circleProgressLoad_right 5s linear infinite;
}

.navigationShow .leftcircle {
  display: flex;
  border: 0.05rem solid transparent;
  border-bottom: 0.05rem solid #144297;
  border-left: 0.05rem solid #144297;
  position: absolute;
  left: 0;
  -webkit-animation: circleProgressLoad_left 5s linear infinite;
}

.navigationShow .circleProgress {
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  -webkit-transform: rotate(-90deg);
}

.navigationShow .circleProgress2 {
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-transform: rotate(210deg);
}

.web {
  display: flex;
  align-items: center;
  height: 1rem;
}

.login {
  height: 1rem;
}

/* @-webkit-keyframes circleProgressLoad_right {
   0% {
      border-top: 20px solid #ed1a1a;
      border-right: 20px solid #ed1a1a;
      -webkit-transform: rotate(45deg);
   }
 
   50% {
      border-top: 20px solid rgb(232, 232, 12);
      border-right: 20px solid rgb(232, 232, 12);
      border-left: 20px solid rgb(81, 197, 81);
      border-bottom: 20px solid rgb(81, 197, 81);
      -webkit-transform: rotate(225deg);
   }
 
   100% {
      border-left: 20px solid green;
      border-bottom: 20px solid green;
      -webkit-transform: rotate(225deg);
   }
}
 
@-webkit-keyframes circleProgressLoad_left {
   0% {
      border-bottom: 20px solid #ed1a1a;
      border-left: 20px solid #ed1a1a;
      -webkit-transform: rotate(45deg);
   }
 
   50% {
      border-bottom: 20px solid rgb(232, 232, 12);
      border-left: 20px solid rgb(232, 232, 12);
      border-top: 20px solid rgb(81, 197, 81);
      border-right: 20px solid rgb(81, 197, 81);
      -webkit-transform: rotate(45deg);
   }
 
   100% {
      border-top: 20px solid green;
      border-right: 20px solid green;
      border-bottom: 20px solid green;
      border-left: 20px solid green;
      -webkit-transform: rotate(225deg);
   }
} */
.bigbox {
  display: flex;
  height: 1rem;
  backdrop-filter: blur(75px);
  width: 100%;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);

  position: fixed;
  top: 0;
  z-index: 9999;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.logo {
  float: left;
  display: flex;
  margin: 0.25rem 0 0.25rem 0.25rem;

  height: 0.5rem;
  width: 1.8375rem;
}

.logo:hover {
  cursor: pointer;
}

.logo-left {
  height: 0.5rem;
  width: 0.5rem;
}

.logo-right {
  height: 0.375rem;
  width: 1.1875rem;
}

.text {
  float: left;
  margin-left: 0.275rem;
  font-size: 0.215rem;
  display: flex;
  align-items: center;
  font-weight: 400;
  color: #ffffff;
  height: 100%;
  position: relative;
}

.text .navigation-text {
  float: left;
  padding-left: 0.8875rem;
  font-family: 'Alibaba PuHuiTi-Regular';
  display: flex;
  height: 100%;
  align-items: center;
  box-sizing: content-box;
  font-weight: 400;
}

.text .navigation-text:hover {
  cursor: pointer;
}

.navigation-text-list2 {
  opacity: 0.9 !important;
  filter: blur(5px);
  z-index: 0 !important;
}

.navigation-text-list {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 0.125rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  width: 2.5rem;
  box-sizing: border-box;
}

.navigation-text-list-li {
  height: 0.7125rem;
  width: auto;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.navigation-text {
  position: relative;
}

.navigation-text-select {
  padding-top: 0.3125rem;
  position: absolute;
  top: 0.975rem;
  left: 0.8875rem;

  width: 2.5rem;
}

.sanjiao {
  height: 0;
  width: 0;
  border-right: 0.125rem solid rgba(255, 255, 255, 0);
  border-top: 0.1rem solid rgba(255, 255, 255, 0);
  border-left: 0.125rem solid rgba(255, 255, 255, 0);
  border-bottom: 0.1rem solid rgba(255, 255, 255, 0.2);
  margin-left: 0.25rem;
}

.search {

  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 3.625rem;

  height: 100%;

}

.search input {
  -web-kit-appearance: none;
  -moz-appearance: none;
  outline: 0;
  background: transparent;
  border: 0;
  width: 100%;
  height: 100%;
  padding-left: 0.25rem;


  background: rgba(255, 255, 255, 0.2);
}

.search input::-webkit-input-placeholder {
  font-size: 0.225rem;
  color: rgba(255, 255, 255, 0.4);
}


.ser {
  height: 0.2525rem;
  width: 0.2525rem;
  margin-right: 0.2625rem;
  position: absolute;
  right: 4.5rem;
  transition: all .5s ease;
}

.searchClose {
  height: 0.2525rem;
  width: 0.2525rem;
  margin-right: 0.2625rem;
  position: absolute;
  right: 4.5rem;

}

.searchClose:hover {
  cursor: pointer;
}

.searchClose svg {
  height: 0.2525rem;
  width: 0.2525rem;
}

.ser:hover {
  cursor: pointer;
}

.login {
  display: flex;
  align-items: center;
  font-size: 0.225rem;
  color: #ffffff;
  padding-left: 0.5rem;
  width: 1.1125rem;
  justify-content: space-between;
}

.shoop {
  margin-left: 0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.navigationShow .shoop {
  background: rgba(217, 227, 239, 0.4);
}

.shoop img {
  height: 0.25rem;
  width: 0.25rem;
}

.enter:hover {
  cursor: pointer;
}

.register:hover {
  cursor: pointer;
}

.menu {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 30px 30px 30px 30px;
  opacity: 1;
  width: 0.9625rem;
  height: 0.5rem;
  margin-left: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  padding: 0 0.175rem;
}

.navigationShow .menu {
  color: #333333;
  background: rgba(217, 227, 239, 0.4);
}

.menu img {
  width: 0.2rem;
  height: 0.1625rem;
  line-height: 1;
}

.menu div {
  display: flex;
  justify-content: center;
}

.menu div:hover {
  cursor: pointer;
}

.yema {
  position: absolute;

  box-sizing: border-box;
}

.navigationShow .yema {
  background: rgba(217, 227, 239, 0.4);
}

.yema img {
  height: 0.25rem;
  width: 0.25rem;
  position: absolute;
  top: -0.065rem;
  right: -0.01rem;
}

.navigationShow .text {
  color: #333333;
}

.navigationShow .search {
  background-color: #d9e3ef;
}

.navigationShow .search input::-webkit-input-placeholder {
  font-size: 0.225rem;
  color: #728ec1;
}

.navigationShow .login {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/navigation.vue